import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Troll extends Mob {
	constructor(sprites, infoable=true) {
		super(sprites, StandardSheetAnimations.getAnimation("troll"));
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });
		this.substAnimation("idle_n", 1, { row: 10, col: 0 });


		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;

		let traits = {
			clas: "enemy",
			race: "troll",
			openDoors: true,
			static: false,
			qi: BasicAI.QI_LOW,
			speed: Troll.WALK_STEP * Game.MULT,
			radius: Troll.RADIUS,
			runspeed: Troll.RUN_STEP * Game.MULT,
			timeWarns: Troll.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)
	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Troll.RADIUS = 5;
Troll.WALK_STEP = 2;
Troll.RUN_STEP = 4;
Troll.TIME_WARNS = [300, 500];

